export const BookingEvent = {
  en: {
    Event: 'Event',
    Location: 'Location',
    Provider: 'Provider',
    'Booking Service': 'Booking Service',
    Time: 'Time',
    Members: 'Members',
    Search: 'Search',
    Client: 'Client',
    'Add member': 'Add member',
    Add: 'Add',
    Comment: 'Comment',
    Notes: 'Notes',
    'Comment for provider': 'Comment for provider',
    'Last Updated by': 'Last Updated by',
    'Assign services to client': 'Assign services to client',
    'Use after assign': 'Use after assign',
    Assign: 'Assign',
    'Assign Services': 'Assign Services',
    'Members limit': 'Members limit',
    'Available for online': 'Available for online',
    'Assigned Services': 'Assigned Services',
    'New client': 'New client',
    'out of': 'out of',
    Created: 'Created',
    Updated: 'Updated',
    Phone: 'Phone',
    'Wait accept': 'Wait accept',
    'Wait payment': 'Wait payment',
    Success: 'Success',
    'Payment status': 'Payment',
    'Added by user': 'Added by user',
    'In process': 'In process',
    Delete: 'Delete',
    'Delete and refund to deposit': 'Delete and refund to deposit',
    DeleteMemberToDepositConfirmText:
      'Are you sure you want to delete member and return the money to the deposit?',
    DeleteMember: 'Are you sure you want to delete member?',
    'Confirm deletion': 'Confirm deletion',
    'New Client': 'New Client',
    Member: 'Member',
    Update: 'Update',
    'Client is required': 'Client is required',
    'Failed to delete member': 'Failed to delete member',
    'Mobile App': 'Mobile App',
    Services: 'Services',
    Receipt: 'Receipt',
    'Transfer to another event': 'Transfer to another event',
    transfer_same_service:
      'You can only transfer to an event with the same booking service.',
    transfer_cancel_hint:
      'To transfer to a different booking service, cancel the service with a refund to deposit, book the time manually, and purchase the required service using the deposit.',
    'Select event': 'Select event',
    'Event is required': 'Event is required',
    Transfer: 'Transfer',
    'Failed to transfer member': 'Failed to transfer member',
    'Edit member': 'Edit member',
  },
  uk: {
    Event: 'Подія',
    Location: 'Локація',
    Provider: 'Провайдер',
    'Booking Service': 'Букінг Сервіс',
    Time: 'Час',
    Members: 'Учасники',
    Search: 'Пошук',
    Client: 'Клієнт',
    'Add member': 'Додати учасника',
    Add: 'Додати',
    Comment: 'Коментар',
    Notes: 'Нотатки',
    'Comment for provider': 'Коментар для провайдера',
    'Last Updated by': 'Оновив',
    'Assign services to client': 'Присвоєння сервісів клієнту',
    'Assign Services': 'Присвоєння сервісів',
    'Use after assign': 'Використати після присвоєння',
    Assign: 'Присвоїти',
    'Members limit': 'Обмеження кількості учасників',
    'Available for online': 'Доступно для онлайн-запису',
    'Assigned Services': 'Присвоєні сервіси',
    'New client': 'Новий клієнт',
    'out of': 'із',
    Created: 'Створив',
    Updated: 'Оновив',
    Phone: 'Телефон',
    'Wait accept': 'В обробці',
    'Wait payment': 'Очікування оплати',
    Success: 'Успішна',
    'Payment status': 'Оплата',
    'Added by user': 'Доданий адміном',
    'In process': 'Очікується',
    Delete: 'Видалити',
    'Delete and refund to deposit': 'Видалити і повернути на депозит',
    DeleteMemberToDepositConfirmText:
      'Ви впевнені, що хочете видалити учасника та повернути кошти на депозит?',
    DeleteMember: 'Ви впевнені, що хочете видалити учасника?',
    'Confirm deletion': 'Підтвердження видалення',
    'New Client': 'Новий Клієнт',
    Member: 'Учасник',
    Update: 'Оновити',
    'Client is required': "Клієнт обов'язковий",
    'Failed to delete member': 'Не вдалося видалити учасника',
    'Mobile App': 'Мобільний додаток',
    Services: 'Сервіси',
    Receipt: 'Чек',
    'Transfer to another event': 'Перенести на іншу подію',
    transfer_same_service:
      'Перенести можна лише на подію з тим самим букінг сервісом.',
    transfer_cancel_hint:
      'Для переносу на інший букінг сервіс скасуйте сервіс з поверненням коштів на депозит, забронюйте час вручну та здійсніть покупку необхідного сервісу використовуючи депозит.',
    'Select event': 'Виберіть подію',
    'Event is required': "Подія обов'язкова",
    Transfer: 'Перенести',
    'Failed to transfer member': 'Не вдалося перенести учасника',
    'Edit member': 'Редагувати учасника',
  },
};
